module.exports = __webpack_public_path__ + "img/6-3.6f81cefb.jpg";